import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=c6be1244&scoped=true"
import script from "./CustomFooter.vue?vue&type=script&lang=js"
export * from "./CustomFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6be1244",
  null
  
)

export default component.exports